import React from 'react';

// Official Government of Canada maple-leaf geometry (from the national flag specification)
const LEAF = 'M4890 4430l-45-863a95 95 0 0 1 111-98l859 151-116-320a65 65 0 0 1 20-73l941-762-212-99a65 65 0 0 1-34-79l186-572-542 115a65 65 0 0 1-73-38l-105-247-423 454a65 65 0 0 1-111-57l204-1052-327 189a65 65 0 0 1-91-27l-332-652-332 652a65 65 0 0 1-91 27l-327-189 204 1052a65 65 0 0 1-111 57l-423-454-105 247a65 65 0 0 1-73 38l-542-115 186 572a65 65 0 0 1-34 79l-212 99 941 762a65 65 0 0 1 20 73l-116 320 859-151a95 95 0 0 1 111 98l-45 863z';

export const MapleLeaf = ({ className, style }) => (
  <svg className={className} style={style} viewBox="2900 200 3800 4400" aria-hidden="true" fill="#D52B1E">
    <path d={LEAF} />
  </svg>
);

const CorpCanadian = () => (
  <section className="ff-section ff-section-alt corp-canada" data-testid="corp-canadian">
    <MapleLeaf className="leaf" />
    <div className="ff-container ff-form-shell ff-text-center">
      <p className="ff-eyebrow">MADE IN FENELON FALLS, ONTARIO</p>
      <h2>Support Small. Support Local. Support Canadian.<MapleLeaf className="leaf-inline" /></h2>
      <p className="ff-lede">Your corporate gifting can make a bigger impact.</p>
      <p style={{ color: 'var(--ff-brown-soft)', fontSize: 16, lineHeight: 1.7, margin: '12px 0 0' }}>
        When you choose The Lokal, you're supporting a Canadian small business while creating
        something memorable for your clients, employees, partners and guests. We believe great
        business is built through relationships — and we're proud to work alongside Canadian
        entrepreneurs, professionals, local businesses and organizations.
      </p>
    </div>
  </section>
);

export default CorpCanadian;
